<template>
    <BrandableAddonModal 
        v-if="isBrandable" 
        :selectedAddon="selectedAddon"
        :addonProducts="addonProducts"
        :cartProducts="cartProducts"
        :recommendedProducts="recommendedProducts"
        @closemodal="closeModal()"
        @changeselectedaddon="openModal($event)"
    />
    <NormalAddonModal 
        v-else
        :selectedAddon="selectedAddon"
        :addonProducts="addonProducts"
        :cartProducts="cartProducts"
        :recommendedProducts="recommendedProducts"
        @closemodal="closeModal()"
        @changeselectedaddon="openModal($event)"
    />
</template>

<script>
import NormalAddonModal from './AddonModal/NormalAddonModal.vue'
import BrandableAddonModal from './AddonModal/BrandableAddonModal.vue'
export default {
    props: {
        selectedAddon: Object,
        addonProducts: Array,
        cartProducts: Array,
        recommendedProducts: Array,
    },
    data() {
        return {}
    },
    components:{
        NormalAddonModal,
        BrandableAddonModal
    },
    computed:{
        isBrandable(){
            var isBrandable = this.selectedAddon.tags.filter(y => y.includes("Brandable Swag"));
            let designable = this.selectedAddon.tags.filter(y => y.includes("Designable"));
            if(isBrandable && isBrandable.length > 0 && (this.selectedAddon.variants.length > 1 || (designable && designable.length > 0))){
                return true
            }

            return false
        }
    },
    methods:{
        closeModal(){
            this.$emit("closemodal");
        },
        openModal(event){
            this.$emit("changeselectedaddon", event);
        }
    },
}
</script>